/** Suggested Media Type chips — the user can also type a novel value. */
export const MEDIA_TYPE_OPTIONS = [
  'Broadcast',
  'VOD',
  'Format',
  'Digital/AVOD',
  'TV Pay Per View',
  'Home Video',
  'Airline/Rail/Theatrical',
  'Format/Adaptation',
  'Merchandising',
];
